module.exports = __webpack_public_path__ + "img/logo-region.4cc4bfa4.png";